import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../../api/ApiCall";

export const getTakeOffByDrawingId = createAsyncThunk(
  "getTakeOffByDrawingId",
  async (data) => {
    const request = await api(`api/admin/take-off/${data}`, "", "get");
    return request;
  }
);

export const updateDrawingTakeOff = createAsyncThunk(
  "updateDrawingTakeOff",
  async ({ data, drawing_id }) => {
    const request = await api(`api/admin/take-off/${drawing_id}`, data, "post");
    return request;
  }
);

export const deleteTakeOffItem = createAsyncThunk(
  "deleteTakeOffItem",
  async ({ id }) => {
    const request = await api(`api/admin/take-off/${id}`, {}, "delete");
    return request;
  }
);

const drawingTakeOffSlice = createSlice({
  name: "drawingTakeOff",
  initialState: {
    loading: false,
    takeoff: [],
    success: null,
    error: null,
    totalCount: 0,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      // .addCase(listDrawingsByOpportunity.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(listDrawingsByOpportunity.fulfilled, (state, action) => {
      //   state.drawings = action?.payload?.rows;
      //   state.drawings = action?.payload?.rows;
      //   state.totalCount = action?.payload.count;
      //   state.loading = false;
      //   state.error = null;
      // })
      // .addCase(listDrawingsByOpportunity.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message;
      // })
      // .addCase(searchOpportunities.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(searchOpportunities.fulfilled, (state, action) => {
      //   state.opportunities = action?.payload?.rows;
      //   state.totalCount = action?.payload.count;
      //   state.totalEstimatedValue = action?.payload.estimated_value;
      //   state.loading = false;
      //   state.error = null;
      // })
      // .addCase(searchOpportunities.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message;
      // })
      // .addCase(addDrawing.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(addDrawing.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.drawings = action.payload;
      //   state.error = null;
      // })
      // .addCase(addDrawing.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message;
      // })
      .addCase(updateDrawingTakeOff.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDrawingTakeOff.fulfilled, (state, action) => {
        state.loading = false;
        state.takeoff = state.takeoff.map((option) => {
          if (option.id === action.payload.id) {
            return action.payload;
          }
          return option;
        });
        state.success = action.payload.message;
        state.error = null;
      })
      .addCase(updateDrawingTakeOff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteTakeOffItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTakeOffItem.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.error = null;
      })
      .addCase(deleteTakeOffItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default drawingTakeOffSlice.reducer;
